import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

const zBrandForm = z.object({
  image: z.instanceof(File).nullable(),
  name: z.string().nonempty().max(30),
})

export type BrandForm = z.infer<typeof zBrandForm>

// Form hook
export const useBrandForm = (defaultValues?: Partial<BrandForm>) => {
  const form = useForm({
    // Validation function
    defaultValues: {
      name: '',
      image: null,
      ...defaultValues,
    },
    resolver: zodResolver(zBrandForm),
  })

  return form
}
